import React,{useState}from 'react'
import { Modal, Form, Input, Button, App } from 'antd';
import { useGoodsTypeAddMutation,} from '../../store/ReactWebSiteApi';
function GoodsTypeAdd(props) {
    const { message } = App.useApp();
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onCreateClient = (values) => {
        console.log('Received values of form: ', values);
        setOpen(false);
    };
    const [info,setInfo] = useState();
    const [submitAdd] = useGoodsTypeAddMutation()
    return (
        <>
            <Button onClick={() => {setOpen(true);}} type='primary'>新增产品类型</Button>
            <Modal
                open={open}
                title='新增产品类型'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreateClient(values);
                        })
                        .catch((info) => {
                            console.log('Validate Failed:', info);
                        });
                    submitAdd({
                        egt_name:info,
                        egt_e_id:localStorage.getItem('e_id'),
                        egt_uid:localStorage.getItem('eu_id'),
                        egt_uname:localStorage.getItem('eu_name'),
                        egt_esv_id:props.egt_esv_id
                    }).then((res) => {
                        console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('新增成功！')  
                            setOpen(false)                         
                        }
                        if (res.data.Status === 'fail') {
                            message.error('新增失败！'+res.data.Message)
                        }
                    })
                }}
            >
                <Form
                    form={form}
                    layout="horizontal"
                    name="goodsTypeAddForm"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 7 }}
                >                            
                    <Form.Item name="name" label='产品类型' wrapperCol={{span:10}} required>
                        <Input  onChange={(e) => {setInfo(e.target.value)}}/>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default GoodsTypeAdd